export default "__VITE_ASSET__0fc4829c__"